import React from 'react';

function Taiwan(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_123973)">
        <mask
          id="mask0_800_123973"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_123973)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#EF0000"
          />
          <mask
            id="mask1_800_123973"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_123973)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V14H20.25V0H0Z"
              fill="#2E42A5"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.82093 10.8107L8.15406 12.6592L7.7503 10.3175L5.26696 11.1776L6.2345 8.97016L3.6001 8.61126L5.67967 7.1296L3.6001 5.64794L6.2345 5.28905L5.26696 3.08164L7.7503 3.94166L8.15406 1.59998L9.82093 3.44849L11.4878 1.59998L11.8916 3.94166L14.3749 3.08164L13.4074 5.28905L16.0418 5.64794L13.9622 7.1296L16.0418 8.61126L13.4074 8.97016L14.3749 11.1776L11.8916 10.3175L11.4878 12.6592L9.82093 10.8107ZM9.82088 9.99197C11.5993 9.99197 13.041 8.71045 13.041 7.12962C13.041 5.54879 11.5993 4.26728 9.82088 4.26728C8.04245 4.26728 6.60074 5.54879 6.60074 7.12962C6.60074 8.71045 8.04245 9.99197 9.82088 9.99197ZM12.397 7.1296C12.397 8.39426 11.2436 9.41948 9.82089 9.41948C8.39815 9.41948 7.24478 8.39426 7.24478 7.1296C7.24478 5.86493 8.39815 4.83972 9.82089 4.83972C11.2436 4.83972 12.397 5.86493 12.397 7.1296Z"
              fill="#FEFFFF"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_123973">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Taiwan;
